<!-- 销售订单数据操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item v-if="formOneValue.isShow == 1" :key="formOneKey" :prop="formOneValue.entityField" :rules="$common.getFormItemRules(formOneValue, sendDataInfo)">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <!-- 日期 -->
                                                    <df-date v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]" @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                                        :isShowLong="false" :isdisabled="formOneValue.isChange == 0 || (sendDataInfo.woApplyDetails.length > 0 && formOneValue.isUpdate == 0)"
                                                        @focusout.native="onDateBlur(formOneValue.entityField)">
                                                    </df-date>
                                                    <!-- 检索方案 -->
                                                    <el-tooltip v-else-if="formOneValue.entityField == 'coName'" class="item"
                                                        :disabled="(sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false) || sendDataInfo[formOneValue.entityField].length <= 9"
                                                        effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input clearable @input="$common.clearSearch(sendDataInfo, formOneValue.setField,formOneValue.entityField)" @clear="$common.clearSearch(sendDataInfo, formOneValue.setField)"
                                                            v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                            @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                            :disabled="sendDataInfo.woApplyDetails.length > 0 ? true : false">
                                                            <el-button @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" slot="append"
                                                                icon="el-icon-search" :disabled="sendDataInfo.woApplyDetails.length > 0 ? true : false">
                                                            </el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <!-- 检索方案 -->
                                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                        :disabled="(sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false) || sendDataInfo[formOneValue.entityField].length <= 9"
                                                        effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input clearable @input="$common.clearSearch(sendDataInfo, formOneValue.setField,formOneValue.entityField)" @clear="$common.clearSearch(sendDataInfo, formOneValue.setField)"
                                                            v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                            @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                            :disabled="(formOneValue.isChange == 0 || (sendDataInfo.woApplyDetails.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)) && (sendDataInfo[formOneValue.entityField] ? true : false)">
                                                            <el-button @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" slot="append"
                                                                icon="el-icon-search"
                                                                :disabled="(formOneValue.isChange == 0 || (sendDataInfo.woApplyDetails.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)) && (sendDataInfo[formOneValue.entityField] ? true : false)">
                                                            </el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <!-- formatter下拉选   :automatic-dropdown="true"-->
                                                    <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="(e) => {selectChange(e, formOneValue.entityField)}"
                                                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.woApplyDetails.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)" @change="$forceUpdate()"
                                                        v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                    <el-select clearable size="mini" v-else-if="formOneValue.entityField == 'surgeryType'" @visible-change="(e) => {selectChange(e, formOneValue.entityField)}"
                                                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.woApplyDetails.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)" @change="$forceUpdate()"
                                                        v-model="sendDataInfo.surgeryType" placeholder="请选择">
                                                        <el-option v-for="item in surgeryTypeList" :key="item.id" :label="item.surgeryName" :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- formatter下拉选   :automatic-dropdown="true"-->
                                                    <el-select clearable size="mini" v-else-if="formOneValue.entityField == 'saleOrgName'"
                                                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.woApplyDetails.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)" @change="$forceUpdate()"
                                                        v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.XSZZ" :key="dictionariesKey" :label="dictionariesValue.diName"
                                                            :value="dictionariesValue.diValue"></el-option>
                                                    </el-select>
                                                    <!-- 账期 -->
                                                    <el-input @keyup.enter.native="nextFocus(formOneValue.isIndex)" type="number" v-else-if="formOneValue.entityField == 'credit'"
                                                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.woApplyDetails.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)"
                                                        v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                    <div v-else-if="formOneValue.entityField == 'fileUrl'">
                                                        <input style="display: none;" type="file" id="recordExcel" multiple name="recordExcel" @change="(e) => { fileUpload(0, e.target.files, e.target.files.length, 0, e) }" />
                                                        <ul v-if="sendDataInfo[formOneValue.entityField]" class="upload">
                                                            <li v-for="(val, key) in sendDataInfo[formOneValue.entityField].split(',')" :key="key">
                                                                <i class="el-icon-error del" @click="delRemove(0, key)"></i>
                                                                <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                                                                </cusImage>
                                                            </li>
                                                            <li>
                                                                <label for="recordExcel" class="image_label">
                                                                    <i class="el-icon-plus icon"></i>
                                                                </label>
                                                            </li>
                                                        </ul>
                                                        <ul v-else class="upload">
                                                            <li>
                                                                <label for="recordExcel" class="image_label">
                                                                    <i class="el-icon-plus icon"></i>
                                                                </label>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <!-- string类型 -->
                                                    <el-input @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)" v-else
                                                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.woApplyDetails.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)"
                                                        v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item v-if="formOneValue.isShow == 1" :key="formOneKey">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                                    <span v-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
														sendDataInfo[formOneValue.entityField]
													}}</a>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="sendDataInfo[formOneValue.entityField]">
                                                            {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField])
														}}
                                                        </span>
                                                    </span>
                                                    <span v-else-if="formOneValue.entityField == 'isWms'">{{
													sendDataInfo.isWms == 1 ?
														'是' : '否' }}</span>
                                                    <span v-else-if="formOneValue.fieldType == 'formatter'">{{
													getValue(sendDataInfo[formOneValue.entityField],
														formOneValue.entityField, formOneValue.fieldType,
														formOneValue.formatterContent) }}</span>
                                                    <div v-else-if="formOneValue.entityField == 'fileUrl'">
                                                        <ul class="upload" v-if="sendDataInfo[formOneValue.entityField]">
                                                            <li v-for="(val, key) in sendDataInfo[formOneValue.entityField].split(',')" :key="key">
                                                                <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                                                                </cusImage>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                    </el-form>

                                    <!-- 明细操作 -->
                                    <el-form :inline="true" size="mini">
                                        <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                            <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">新增明细</el-button>
                                            <el-button type="primary" size="mini" @click="deleteDetails()" :disabled="sendDataInfo.woApplyDetails.length < 1">删除明细</el-button>
                                            <el-button type="primary" size="mini" @click="openStockRegisterBox()">缺货登记
                                            </el-button>
                                            <el-button type="primary" size="mini" @click="openPriceApplicationBox()">
                                                特价申请</el-button>
                                            <el-button type="primary" v-if="!addressShow" size="mini" @click="openAddress">维护客户地址
                                            </el-button>
                                            <el-button type="primary" size="mini" @click="lookLicence()">查看证照
                                            </el-button>
                                            <el-button type="primary" v-if="tabForm[0].isExtract == 1" :disabled="dataActionBox.actionType == 1" size="mini" @click="openExtSearch('629899519725568')">提取外部订单</el-button>
                                            <el-button :disabled="dataActionBox.actionType == 1" @click="openExtSearch('1721092115898', 'conmId')" type="primary" size="mini">提取销售合同</el-button>
                                            <el-button @click="exportTemplate" size="mini" type="primary">下载模版</el-button>
                                            <el-button @click="importDetails" size="mini" type="primary">导入明细</el-button>
                                            <el-dropdown style="margin-left: 5px;" v-if="$store.state.btnlist" trigger="click">
                                                <el-button type="primary">
                                                    辅助功能<i class="el-icon-arrow-down el-icon--right"></i>
                                                </el-button>
                                                <template #dropdown>
                                                    <el-dropdown-menu slot="dropdown">
                                                        <el-dropdown-item v-for="(item, index) in JSON.parse($store.state.btnlist)" :key="index" @click.native="Historical(item.mdSource, item.mdName)">{{
																item.mdName
															}}</el-dropdown-item>
                                                    </el-dropdown-menu>
                                                </template>
                                            </el-dropdown>
                                            <el-link :underline="false" type="danger" style="margin-left: 10px;">
                                                (Alt+F1：新增明细</el-link>
                                            <el-link :underline="false" type="danger" style="margin-left: 10px;">
                                                Alt+F2/Delete：删除明细)</el-link>
                                        </div>
                                        <!-- 明细信息 -->
                                        <el-table class="baseTable" v-if="mxForm" ref="mxTableRef" :data="sendDataInfo.woApplyDetails" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                            @selection-change="handleSelectionChange" border size="mini" :height="mxHeight">
                                            <el-table-column width="80" label="选择" v-if="dataActionBox.actionType != 2">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <el-table-column type="index" width="50" label="序号"> </el-table-column>
                                            <template v-for="(formOneValue, formOneKey) in mxForm.jurconfigform">
                                                <el-table-column v-if="formOneValue.isShow == 1" :key="formOneKey" :prop="formOneValue.entityField" :label="formOneValue.showField" :min-width="formOneValue.fieldWeight" show-overflow-tooltip>
                                                    <template slot-scope="scope">
                                                        <!-- 显示通用名称 -->
                                                        <el-input :ref="formOneValue.entityField" v-if="formOneValue.entityField == 'bgmName'
														&& dataActionBox.actionType != 2 && formOneValue.isChange == 1" clearable
                                                            @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '', formOneValue.focusField, formOneValue.nosetField, formOneValue.setField)"
                                                            v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                            <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '', formOneValue.focusField, formOneValue.nosetField, formOneValue.setField)"
                                                                slot="append" icon="el-icon-search">
                                                            </el-button>
                                                        </el-input>
                                                        <span v-else-if="formOneValue.isRift == 1">
                                                            <a @click="toDetail(sendDataInfo.woApplyDetails[scope.$index][formOneValue.riftField])">
                                                                {{
																sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]
															}}</a>
                                                        </span>
                                                        <!-- 生产日期 -->
                                                        <span v-else-if="formOneValue.fieldType == 'date'">
                                                            <span v-if="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                                {{
																$common.getLocalTime(sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField])
															}}
                                                            </span>
                                                        </span>

                                                        <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index, formOneValue.entityField)" :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'woadPnumber'
															&& dataActionBox.actionType != 2 && formOneValue.isChange == 1" type="number" @input="calculatePrice(5, scope.$index,false,'tbNumber')" v-model="sendDataInfo.woApplyDetails[scope.$index].woadPnumber">
                                                        </el-input>
                                                        <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index, formOneValue.entityField)" :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'tbNumber'
															&& dataActionBox.actionType != 2 && formOneValue.isChange == 1" type="number" @input="calculatePrice(10, scope.$index)"
                                                            v-model="sendDataInfo.woApplyDetails[scope.$index].tbNumber">
                                                        </el-input>

                                                        <!-- 含税价格  -->
                                                        <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index, formOneValue.entityField)" :ref="formOneValue.entityField" type="number"
                                                            v-else-if="formOneValue.entityField == 'psprice'
															&& dataActionBox.actionType != 2 && formOneValue.isChange == 1" :disabled="sendDataInfo.woApplyDetails[scope.$index].woadPnumber <= 0" @blur="doCheckPrice(2, scope.$index, formOneValue.entityField, formOneValue.focusField)"
                                                            @input="calculatePrice(2, scope.$index)" v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- 单价 -->
                                                        <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'price'
															&& dataActionBox.actionType != 2 && formOneValue.isChange == 1" type="number" :disabled="sendDataInfo.woApplyDetails[scope.$index].woadPnumber <= 0" @input="calculatePrice(1, scope.$index)"
                                                            v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- 最低售价 -->
                                                        <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number" v-else-if="formOneValue.entityField == 'lowestPrice'
															&& dataActionBox.actionType != 2 && formOneValue.isChange == 1" :disabled="sendDataInfo.woApplyDetails[scope.$index].woadPnumber <= 0" @input="calculatePrice(2, scope.$index)"
                                                            v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- 总金额 -->
                                                        <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number" v-else-if="formOneValue.entityField == 'money'
															&& dataActionBox.actionType != 2 && formOneValue.isChange == 1" :disabled="sendDataInfo.woApplyDetails[scope.$index].woadPnumber <= 0" @input="calculatePrice(3, scope.$index)"
                                                            v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                        </el-input>

                                                        <!-- 含税金额 -->
                                                        <el-input @mousewheel.native.prevent v-else-if="formOneValue.entityField == 'psmoney'
														&& dataActionBox.actionType != 2 && formOneValue.isChange == 1" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number"
                                                            :disabled="sendDataInfo.woApplyDetails[scope.$index].woadPnumber <= 0" @input="calculatePrice(4, scope.$index)"
                                                            v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- 含税金额 -->
                                                        <el-input @mousewheel.native.prevent v-else-if="formOneValue.entityField == 'saleQuprice'
														&& dataActionBox.actionType != 2 && formOneValue.isChange == 1" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number"
                                                            :disabled="sendDataInfo.woApplyDetails[scope.$index].woadPnumber <= 0" @input="calculatePrice(6, scope.$index)"
                                                            v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- 含税金额 -->
                                                        <el-input @mousewheel.native.prevent v-else-if="formOneValue.entityField == 'saleQumoney'
														&& dataActionBox.actionType != 2 && formOneValue.isChange == 1" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number"
                                                            :disabled="sendDataInfo.woApplyDetails[scope.$index].woadPnumber <= 0" @input="calculatePrice(7, scope.$index)"
                                                            v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- 含税金额 -->
                                                        <el-input @mousewheel.native.prevent v-else-if="formOneValue.entityField == 'outRate' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                            @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number" @input="calculatePrice(4, scope.$index)"
                                                            v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- 折前价格 -->
                                                        <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" @input="calculatePrice(5, scope.$index)" :ref="formOneValue.entityField"
                                                            v-else-if="formOneValue.entityField == 'disPreprice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :maxlength="$store.state.inputLength" type="number"
                                                            v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- 含税原价 -->
                                                        <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" @input="calculatePrice(8, scope.$index)" :ref="formOneValue.entityField"
                                                            v-else-if="formOneValue.entityField == 'orPsprice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :maxlength="$store.state.inputLength" type="number"
                                                            v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- 不含税原价 -->
                                                        <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" @input="calculatePrice(9, scope.$index)" :ref="formOneValue.entityField"
                                                            v-else-if="formOneValue.entityField == 'orPrice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :maxlength="$store.state.inputLength" type="number"
                                                            v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- 新含税原价 -->
                                                        <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" @blur="doCheckPrice(9, scope.$index, formOneValue.entityField, formOneValue.focusField)" @input="calculatePrice(10, scope.$index)" :ref="formOneValue.entityField"
                                                            v-else-if="formOneValue.entityField == 'newPsprice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :maxlength="$store.state.inputLength" type="number"
                                                            v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- 备注 -->
                                                        <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'woadRemark'
															&& dataActionBox.actionType != 2 && formOneValue.isChange == 1" v-model.trim="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                        </el-input>

                                                        <el-select v-else-if="formOneValue.entityField == 'isTicket'" v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]" placeholder="请选择">
                                                            <el-option label="是" :value="1"></el-option>
                                                            <el-option label="否" :value="0"></el-option>
                                                        </el-select>
                                                        <span v-else>
                                                            {{
															sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]
														}}
                                                        </span>
                                                    </template>
                                                </el-table-column>
                                            </template>
                                        </el-table>
                                    </el-form>

                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :btnFlag="true" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
            <el-dialog title="缺货登记" :visible.sync="stockRegisterBox" width="500px" center top="2rem" :modal-append-to-body='true' :append-to-body="true">
                <el-form label-width="80px" size="mini">
                    <el-form-item label="客户">
                        <el-input v-model="stockRegisterData.cmName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="货主">
                        <el-input v-model="stockRegisterData.coName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="商品">
                        <el-input v-model="stockRegisterData.bgmName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="规格">
                        <el-input v-model="stockRegisterData.spec" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="产地">
                        <el-input v-model="stockRegisterData.placeorigin" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="包装单位">
                        <el-input v-model="stockRegisterData.bgpUnitmeasurement" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="缺货数量">
                        <el-input v-model="stockRegisterData.wolrRegnumber"></el-input>
                    </el-form-item>
                    <el-form-item label="备注说明">
                        <el-input v-model="stockRegisterData.wolrRemark"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="stockRegisterBox = false">取 消</el-button>
                    <el-button type="primary" @click="addShortageRegistration">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog title="特价申请" :visible.sync="priceApplicationBox" width="60%" center top="2rem" :modal-append-to-body='true' :append-to-body="true">
                <el-form label-position="right" label-width="160px" size="mini">
                    <el-form-item label="销售单位">
                        <el-input v-model="priceApplicationData.cmName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="商品">
                        <el-input v-model="priceApplicationData.bgmName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="批号">
                        <el-input v-model.trim="priceApplicationData.batchno" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="货主">
                        <el-input v-model.trim="priceApplicationData.coName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="生产日期">
                        <el-date-picker v-model="priceApplicationData.prodate" disabled type="date" placeholder="生产日期" format="yyyy 年 MM 月 dd 日" value-format="timestamp">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="有效期">
                        <el-date-picker v-model="priceApplicationData.expidate" disabled type="date" placeholder="有效期" format="yyyy 年 MM 月 dd 日" value-format="timestamp">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="申请售价">
                        <el-input @mousewheel.native.prevent type="number" v-model="priceApplicationData.wosaAppprice"></el-input>
                    </el-form-item>
                    <el-form-item label="申请原因">
                        <el-input v-model.trim="priceApplicationData.wosaAppreason"></el-input>
                    </el-form-item>
                    <el-form-item label="申请截止日期">
                        <el-date-picker v-model="priceApplicationData.wosaEnddate" type="date" placeholder="有效期" format="yyyy 年 MM 月 dd 日" value-format="timestamp" @change="changeTime(priceApplicationData.wosaEnddate)">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="priceApplicationBox = false">取 消</el-button>
                    <el-button type="primary" @click="addSpecialPriceApply">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <printPlan ref="printPlan"></printPlan>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchSchemeOther :oneFlag="oneFlag" :isRepetition="isRepetition" :isRepetitionList="isRepetitionList" :isProp="'bgsId'" ref="SearchSchemeOther" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
                @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <customerAddress ref="customerAddress"></customerAddress>
        <operSelect ref="operSelect" @drawerCancel="drawerCancel" @conAdd="conAdd"></operSelect>
        <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
            <ExtractionScheme :extractParamsData="sendDataInfo" ref="extractionScheme" :interceptFlag="interceptFlag" :id="exId" :ppId="ppId" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
        </el-dialog>
        <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true" :before-close="showClose">
            <el-table :data="dialogList" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
                <el-table-column prop="validity" label="有效期" min-width="100">
                    <template slot-scope="{row}">
                        {{ $common.getLocalTime(row.validity) }}
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showClose">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="导入" v-if="importShow" :visible.sync="importShow" width="30%" append-to-body modal-append-to-body>
            <initDataUpload v-if="importShow" :parentSearchData="importObj" :url="url" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
            </initDataUpload>
        </el-dialog>
        <component :is="currentComponent" :ref="currentComponent"></component>
        <div v-show="false">{{ some }}</div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import SearchScheme from "../byComponents/SearchScheme.vue";
import customerAddress from '@/components/customerAddress.vue';

export default {
    name: "salesOrderAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionScheme,
        customerAddress
    },
    data() {
        //这里存放数据
        return {
            addressShow: window.global_config.addressShow,
            imgUrl: window.global_config.BASE_IMG_URL,
            currentComponent: "",
            historicalOrder: {
                cmName: "",
                cmId: "",
                bgmName: "",
                bgmId: "",
            },
            //--------------------
            showDialog: false,
            showDialog1: false,
            flags: false,
            flag: -1,
            blurData: "",
            dialogList: [],
            // 规则弹窗标记：仅合同到期校验流程使用，-1 表示只有预警可继续提交
            showStatus: null,
            focusIndex: "",
            dictionariesDatas: [], //配送方式
            detailRules: false, //规则
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            inputel: "", //所有input对象
            detaislDataInfo: {},
            showTabs: "",
            formDataList: [],
            dictionariesData: {},
            // userOneList:[],
            selectedDetailsIndex: 0,
            // 缺货登记
            stockRegisterBox: false,
            stockRegisterData: {
                bgmId: "",
                bgmName: "",
                cmId: "",
                cmName: "",
                wolrRegnumber: "",
                wolrRemark: "",
                coId: "",
                coName: "",
            },
            storageRoomList: [], //库房
            // 特价申请
            priceApplicationBox: false,
            priceApplicationData: {
                bgmId: "", //商品
                bgmName: "",
                coId: "", //货主
                coName: "",
                wosaSalecus: "",
                cmId: "",
                cmName: "",
                wosaAppprice: "", // 申请售价
                wosaAppreason: "", // 申请原因
                batchno: "", // 批号
                expidate: "", // 	有效期
                wosaEnddate: "", // 申请截止日期
                wosaMinprice: "", // 最低售价
                prodate: "", // 	生产日期
                acType: 0, // 0自动提交，1手动提交
            },
            editDateilsIndex: "",
            giftsList: [],
            seTitle: "", //检索
            DialogVisible: false,
            seId: 0,
            cmId: "",
            ormId: "",
            coId: 0,
            seType: "",
            setField: "",
            seIndex: 0,
            levleId: 0,
            seWidth: "0",
            mxHeight: 0,
            isLoaded: false,
            pageType: "one",
            parentSearchData: {
                orderType: 0, //	订单类型0.药品1.器械
            },
            selectedRow: [], // 当前已选择行
            mainFormList: [], //过滤的主表单
            tabForm: [], // tab循环的主表单
            mxForm: [],
            footForm: [],
            sField: "", // 赋值字段
            fField: "", //焦点字段
            nosField: "", // 不可赋值字段
            interceptFlag: false,//提取是否调用拦截
            DialogExtract: false, //提取
            exId: "",
            exTitle: "",
            exWidth: "",
            ppId: "orderId",
            ticket: 0,
            nextSearch: false,
            some: 0,
            dictionariesData: {},//字典
            isRepetitionList: [],
            isRepetition: false,
            oneFlag: false,
            surgeryTypeList: [],
            importShow: false,
            importType: "",
            url: "",
            importObj: {
                coId: "",
                stId: "",
            },
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.woApplyDetails": {
            handler: function (newValue, oldValue) {
                const processedData = [];
                this.sendDataInfo.totalCount = 0; //总条目数
                let totalMoney = 0;
                let totalGprofit = 0;
                let totalNumber = 0;
                let totalCostMoney = 0;
                let totalRrmoney = 0;
                for (let i = 0; i < newValue.length; i++) {
                    const item = newValue[i];
                    const keyIndex = i;
                    const processedItem = { ...this.sendDataInfo.woApplyDetails[keyIndex] };

                    // 处理null值
                    for (let key in item) {
                        if (item[key] == null || item[key] == "null") {
                            processedItem[key] = "";
                        } else {
                            processedItem[key] = item[key];
                        }
                    }

                    // 设置字段值
                    processedItem.disPreprice = this.$common.updataNum('disPreprice', item).disPreprice;
                    processedItem.woadPnumber = this.$common.updataNum('woadPnumber', item).woadPnumber;
                    processedItem.tbNumber = this.$common.updataNum('tbNumber', item).tbNumber;
                    processedItem.lastSelesPrice = this.$common.updataNum('lastSelesPrice', item).lastSelesPrice;
                    processedItem.lowestPrice = this.$common.updataNum('lowestPrice', item).lowestPrice;
                    processedItem.saleQuprice = this.$common.updataNum('saleQuprice', item).saleQuprice || 0;
                    processedItem.saleQumoney = this.$common.updataNum('saleQumoney', item).saleQumoney || 0;
                    processedItem.price = this.$common.updataNum('price', item).price || 0;
                    processedItem.psprice = this.$common.updataNum('psprice', item).psprice || 0;
                    if (processedItem.orPsprice != undefined) {
                        processedItem.orPsprice = this.$common.updataNum('orPsprice', item).orPsprice || 0;
                    }
                    if (processedItem.orPrice != undefined) {
                        processedItem.orPrice = this.$common.updataNum('orPrice', item).orPrice || 0;
                    }
                    processedData.push(processedItem);

                    // 累加总金额（暂存）
                    totalMoney = NP.plus(totalMoney, (item.psmoney || 0));
                    totalGprofit = NP.plus(totalGprofit, (item.gross || 0));
                    totalNumber = NP.plus(totalNumber, (item.woadPnumber || 0));
                    totalCostMoney = NP.plus(totalCostMoney, (item.costMoney || 0));
                    totalRrmoney = NP.plus(totalRrmoney, (item.rrPsmoney || 0));
                }

                // 批量更新woApplyDetails
                for (let i = 0; i < processedData.length; i++) {
                    Object.assign(this.sendDataInfo.woApplyDetails[i], processedData[i]);
                }

                // 一次性更新总计数据
                this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, totalMoney);
                this.sendDataInfo.totalGprofit = this.$common.getDecimalInfo(3, totalGprofit);
                this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(1, totalNumber);
                this.sendDataInfo.totalCostMoney = this.$common.getDecimalInfo(3, totalCostMoney);
                this.sendDataInfo.totalRrmoney = this.$common.getDecimalInfo(3, totalRrmoney);
                this.sendDataInfo.totalCount = newValue.length;
            },
            deep: true,
        },
        "sendDataInfo.salesName": {
            handler: function (newstr, oldValue) {
                if (!newstr) {
                    this.sendDataInfo.salesId = ''
                    this.sendDataInfo.sprmId = ''
                }
            },
            deep: true,
        },
        "sendDataInfo.opmName": {
            handler: function (newstr, oldValue) {
                if (!newstr) {
                    this.sendDataInfo.opmId = ''
                    this.sendDataInfo.sprmId = ''
                }
            },
            deep: true,
        },
        "sendDataInfo.recName": {
            handler: function (newstr, oldValue) {
                if (!newstr) {
                    this.sendDataInfo.recId = ''
                    this.sendDataInfo.sprmId = ''
                }
            },
            deep: true,
        },
        "sendDataInfo.coName": {
            handler: function (newstr, oldValue) {
                if (!newstr) {
                    this.sendDataInfo.coId = ''
                    this.sendDataInfo.sprmId = ''
                }
            },
            deep: true,
        },
        "sendDataInfo.cmName": {
            handler(newValue, oldValue) {
                if (newValue == '') {
                    if (this.dataActionBox.actionType == 0 || (this.dataActionBox.actionType == 1 && this.sendDataInfo.woApplyDetails.length == 0)) {
                        this.sendDataInfo.cmId = ''
                        this.sendDataInfo.salesId = ''
                        this.sendDataInfo.salesName = ''
                        this.sendDataInfo.caiId = ''
                        this.sendDataInfo.caiAddress = ''
                        this.sendDataInfo.recId = ''
                        this.sendDataInfo.recName = ''
                        this.sendDataInfo.lastRecedate = ''
                        this.sendDataInfo.sprmId = ''
                    }
                } else if (newValue != oldValue && oldValue != '') {
                    if (this.dataActionBox.actionType == 0 || this.dataActionBox.actionType == 1 && this.sendDataInfo.woApplyDetails.length == 0) {
                        this.sendDataInfo.salesId = ''
                        this.sendDataInfo.salesName = ''
                        this.sendDataInfo.caiId = ''
                        this.sendDataInfo.caiAddress = ''
                        this.sendDataInfo.recId = ''
                        this.sendDataInfo.recName = ''
                        this.sendDataInfo.secondcmName = ''
                        this.sendDataInfo.secondcmId = ''
                        this.sendDataInfo.lastRecedate = ''
                        this.sendDataInfo.sprmId = ''
                    }
                }
            },
        },
        "sendDataInfo.dismode": {
            handler: function (newstr, oldValue) {
                console.log(newstr, "dismodedismode")
                this.$nextTick(() => {
                    let newValue = ""
                    if (!newstr) {
                        newValue = ""
                    } else {
                        newValue = newstr.replace(/\s*/g, "");
                    }
                    this.sendDataInfo.dismode = newValue;
                    if (newValue == "物流") {
                        // this.sendDataInfo.companyName = "";
                        // this.sendDataInfo.loId = "";
                        this.tabForm[0].jurconfigform.forEach((item) => {
                            if (item.entityField == "companyName") {
                                item.isShow = 1;
                            }
                            if (item.entityField == "pickupName") {
                                item.isShow = 0;
                            }
                        });
                    } else if (newValue.includes("自提")) {
                        // this.sendDataInfo.pickupName = "";
                        // this.sendDataInfo.pickupId = "";
                        this.tabForm[0].jurconfigform.forEach((item) => {
                            if (item.entityField == "pickupName") {
                                item.isShow = 1;
                            }
                            if (item.entityField == "companyName") {
                                item.isShow = 0;
                            }
                        });
                    } else {

                        this.tabForm[0].jurconfigform.forEach((item) => {
                            if (item.entityField == "companyName") {
                                this.sendDataInfo.companyName = "";
                                this.sendDataInfo.loId = "";
                                item.isShow = 0;
                            }
                            if (item.entityField == "pickupName") {
                                this.sendDataInfo.pickupName = "";
                                this.sendDataInfo.pickupId = "";
                                item.isShow = 0;
                            }
                        });
                    }
                    var index = 0
                    this.tabForm[0].jurconfigform.forEach(item => {
                        if (item.isShow == 1) {
                            item.isIndex = index
                            index++
                        }
                    })
                });
                this.some++;
                this.$forceUpdate();
            },
            deep: true,
        },
        DialogVisible() {
            if (!this.DialogVisible) {
                this.nextSearch = false;
            }
        },
    },
    //方法集合
    methods: {
        //删除随货通行
        delRemove(val, key) {
            switch (val) {
                case 0://图片
                    var arr = this.sendDataInfo.fileUrl.split(',')
                    arr.splice(key, 1)
                    this.sendDataInfo.fileUrl = arr.join()
                    break;
                default:
                    break;
            }

        },
        //上传随货同行 2 上传质检 1
        async fileUpload(val, files, length, index, e) {
            if (length - 1 >= index) {
                const params = {
                    file: files[index]
                }
                const response = await this.$http.uploadFile(params, true)
                if (response.status == 200) {
                    var arr = []
                    if (val == 0) {//图片
                        if (this.sendDataInfo.fileUrl) {
                            arr = this.sendDataInfo.fileUrl.split(',')
                        }
                    }
                    arr.push(response.result[0].fileUrl)
                    this.sendDataInfo.fileUrl = arr.join()
                    this.fileUpload(val, files, length, index + 1, e)
                } else {
                    e.target.value = ""
                    this.$message.error(response.message)
                }
            } else {
                e.target.value = ""
            }
        },
        // 触发组件的提交
        fileSuccess(val) {
        },
        // 关闭弹窗
        closeExcel(val) {
            this.importShow = false
            if (val.list.length > 0) {
                var list = []
                val.list.forEach(item => {
                    list.push({})
                    for (const key in item) {
                        this.$set(list[list.length - 1], key, item[key])
                    }
                })
                this.sendDataInfo.woApplyDetails.push(...list)
                this.sendDataInfo.woApplyDetails.forEach((item, index) => {
                    this.calculatePrice(5, index)
                })
            }
        },
        exportTemplate() {
            window.location.href = `${window.global_config.BASE_URL}/woApply/downSuDetailExcel`
        },
        importDetails() {
            this.$refs['sendDataInfo'].validate((valid) => {
                if (valid) {
                    this.importType = 'exportSuDetail'
                    this.url = 'woApply/exportSuDetail'
                    this.importObj.coId = this.sendDataInfo.coId
                    this.importObj.stId = this.sendDataInfo.stId
                    this.importShow = true
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'smIntype') {
                this.dictionariesDatas.forEach(item => {
                    if (item.diValue === val) {
                        str = item.diName
                    }
                })
            } else if (fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value === val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key === val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        async blur(focusField, index, ownField, title) {
            setTimeout(async () => {
                //失去焦点事件和点击事件冲突addDetail
                if (title == "blur") {
                    this.blurData = title;
                } else {
                    this.blurData = "";
                }
                if (this.flags) {
                    this.flags = false;
                    return;
                }
                this.fField = focusField;
                this.seIndex = index;
                this.seType = ownField;
                let params = {
                    formId: this.formDataList[1].jciId,
                    num: "",
                    psprice: "",
                };
                if (ownField == "woadPnumber") {
                    params.num = this.sendDataInfo.woApplyDetails[index][ownField];
                } else if (ownField == "psprice") {
                    params.psprice =
                        this.sendDataInfo.woApplyDetails[index][ownField];
                }
                if (ownField) {
                    await this.$http.interceptSuNumPsPrice(params).then((res) => {
                        this.flag = -1;
                        if (res.result != null && res.result.length > 0) {
                            this.dialogList = res.result;
                            this.flag = this.dialogList.findIndex(
                                (item) => item.level == 0
                            );
                        } else {
                            if (
                                this.sendDataInfo.woApplyDetails[index][ownField] != 0
                            ) {
                                this.tableNextFocus(this.fField, this.seIndex);
                            }
                        }
                        if (this.flag == 0) this.showDialog1 = true;
                        if (this.flag != -1) {
                            this.$nextTick(() => {
                                if (title != "blur") {
                                    this.flags = true;
                                }
                                this.sendDataInfo.woApplyDetails[index][ownField] = 0;
                                this.$refs[ownField][index].blur();
                            });
                        }
                    });
                }
            }, 150);
        },
        intercept() {
            this.showDialog1 = false;

            if (this.flag == -1) {
                this.tableNextFocus(this.fField, this.seIndex);
            } else {
                this.$nextTick(() => {
                    this.$refs[this.seType][this.seIndex].focus();
                });
            }
        },
        tabHeight(val) {
            this.mxHeight = val;
        },
        Historical(url, title) {
            this.currentComponent = url;
            if (this.currentComponent == "historicalSalesOrder") {
                this.historicalOrder.cmName = this.sendDataInfo["cmName"];
                this.historicalOrder.cmId = this.sendDataInfo["cmId"];
            }
            if (this.sendDataInfo["woApplyDetails"].length > 0) {
                this.historicalOrder.bgmId =
                    this.sendDataInfo["woApplyDetails"][
                        this.selectedDetailsIndex
                    ].bgmId;
                this.historicalOrder.bgmName =
                    this.sendDataInfo["woApplyDetails"][
                        this.selectedDetailsIndex
                    ].bgmName;
            }
            this.$nextTick(() => {
                this.$refs[this.currentComponent].openBox(
                    this.historicalOrder,
                    title
                );
            });
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.priceApplicationData.wosaEnddate = time;
            }
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        // 销售日期失焦后，按账期重新计算收款日期（不改 df-date，用 focusout 冒泡）
        onDateBlur(field) {
            if (field !== 'woamSaledate') return;
            this.$nextTick(() => {
                if (this.sendDataInfo.creditperiod && this.sendDataInfo.creditperiod !== 0) {
                    this.sendDataInfo.lastRecedate = this.queryDay(this.sendDataInfo.creditperiod);
                }
            });
        },
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e, field) {
            // 抽单切换后重新计算收款日期（visible-change 关闭时 isPick 已更新）
            if (field == 'isPick' && e == false) {
                if (this.sendDataInfo.creditperiod && this.sendDataInfo.creditperiod !== 0) {
                    this.sendDataInfo.lastRecedate = this.queryDay(this.sendDataInfo.creditperiod);
                }
            }
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index);
                        break;
                    }
                }
            }
        },

        // 输入框切换焦点
        nextFocus(index, fField) {
            if (index >= this.inputel.length - 1) {
                if (this.sendDataInfo.woApplyDetails.length > 0) {
                }
                this.addDetail("sendDataInfo");
                return;
            }
            if (fField == "keydown") {
                this.addDetail("sendDataInfo");
                return;
            }
            var aindex = index + 1;
            if (
                this.inputel[aindex].value != "" ||
                this.inputel[aindex].disabled
            ) {
                this.nextFocus(aindex);
                return;
            }
            this.$nextTick(() => {
                this.inputel[aindex].focus();
            });
        },

        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },
        closeChild() {
            this.parentSearchData.bgmId = "";
            this.parentSearchData.bgmName = "";
            addEventListener("keyup", this.keyUp); //创建监听键盘事件
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            this.seIndex = index;
            if (field == "keydown") {
                this.addDetail("sendDataInfo");
                return;
            } else if (field == "keydownnum") {
                if (this.sendDataInfo.woApplyDetails[index + 1] != undefined) {
                    this.$refs["woadPnumber"][index + 1].focus();
                    this.selectedDetailsIndexChange(index + 1);
                    return;
                } else {
                    this.addDetail("sendDataInfo");
                    return;
                }
            } else if (field == "keydownprice") {
                if (this.sendDataInfo.woApplyDetails[index + 1] != undefined) {
                    this.$refs["psprice"][index + 1].focus();
                    this.selectedDetailsIndexChange(index + 1);
                    return;
                } else {
                    this.addDetail("sendDataInfo");
                    return;
                }
            }
            this.$refs[field][index].focus();
        },
        selectedDetailsIndexChange(value) {
            this.selectedDetailsIndex = value;
            this.$nextTick(() => {
                let refsElTable = this.$refs.mxTableRef;
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(
                    this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                );
            });
        },
        // 监听键盘事件
        keyUp(e) {
            if (e.key == "F1") {
                // 右键新增明细
                e.preventDefault();
                this.addDetail("sendDataInfo");
                return;
            } else if (e.key == "F2" || e.key == "Delete") {
                e.preventDefault();
                this.deleteDetails();
            } else if (e.key == "F4" && this.dataActionBox.actionType != 2) {//保存
                this.sendDataAction('sendDataInfo')
            } else if (e.keyCode == 40) {
                // 下键
                // 表格为空，不执行下方
                if (this.sendDataInfo.woApplyDetails.length == 0) return;
                let refsElTable = this.$refs.mxTableRef;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (
                        this.selectedDetailsIndex ==
                        this.sendDataInfo.woApplyDetails.length - 1
                    ) {
                        // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0;
                    } else {
                        // 正常递增
                        this.selectedDetailsIndex++;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.woApplyDetails[
                            this.selectedDetailsIndex
                            ],
                            false
                        );
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            } else if (e.keyCode == 38) {
                // 上键
                if (this.sendDataInfo.woApplyDetails.length == 0) return;
                let refsElTable = this.$refs.mxTableRef;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (this.selectedDetailsIndex == 0) {
                        // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex =
                            this.sendDataInfo.woApplyDetails.length - 1;
                    } else {
                        // 正常递减
                        this.selectedDetailsIndex--;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.woApplyDetails[
                            this.selectedDetailsIndex
                            ],
                            false
                        );
                        return;
                    }
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            }
        },

        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
            let rowBackground = {};
            if (row.bgColor && row.bgColor != "")
                rowBackground.backgroundColor = row.bgColor;
            return rowBackground;
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {};
            this.selectedDetailsIndex = row.rowIndex;
            findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },

        // 查看证照
        lookLicence() {
            if (this.sendDataInfo.cmId == "") {
                return this.$message({
                    message: "请先选择销售单位",
                    type: "warning",
                });
            }
            this.$parent.$parent.toDetail(this.sendDataInfo.cmId);
        },

        // 打开维护地址
        openAddress() {
            if (this.sendDataInfo.cmId == "") {
                return this.$message({
                    message: "请先选择销售单位",
                    type: "warning",
                });
            }
            this.$refs["customerAddress"].openBox(
                0,
                this.sendDataInfo.cmId,
                "",
                "sales"
            );
        },

        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },

        //换行提示
        lineMessageBox(data) {
            console.log(data);

            let txtArr = data.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },
        //触发提取
        openExtSearch(id, type) {
            this.interceptFlag = false
            if (type == 'conmId') {
                this.ppId = type
            } else {
                this.ppId = 'orderId'
            }
            if (id == '1721092115898') {
                this.interceptFlag = true
            }
            this.exId = id;
            this.DialogExtract = true;
        },
        //提取返回
        async getDataByChen(val) {
            if (val != "" || val != undefined) {
                for (let key in val) {
                    if (key == "arrlistbychen") {
                        if (this.ppId == 'conmId') {
                            let arr = []
                            val.arrlistbychen.forEach(item => {
                                arr.push(
                                    {
                                        "bgmId": item.bgmId,
                                        "coId": val.coId,
                                        "condId": item.condId,
                                        "cmId": val.cmId,
                                        "ftNum": item.num
                                    }
                                )
                            })
                            this.$http.sucontractQueryFtDetail(arr).then(res => {
                                if (res.status == 200) {
                                    this.sendDataInfo.woApplyDetails = res.result
                                    this.sendDataInfo.woApplyDetails.forEach((item, index) => {
                                        this.sendDataInfo.totalMoney += item.rrdPsmoney;
                                        this.sendDataInfo.totalNumber += item.oldNum;
                                        this.calculatePrice(false, index)

                                    });
                                    this.sendDataInfo.totalCount = this.sendDataInfo.woApplyDetails.length;
                                    this.$nextTick(() => {
                                        this.selectedDetailsIndex = 0;
                                        let refsElTable = this.$refs.mxTableRef;
                                        refsElTable.clearSelection();
                                        refsElTable.toggleRowSelection(
                                            this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                                        );
                                        this.nextFocus(0);
                                    });
                                } else {
                                    this.$message.error(res.message)
                                }
                            })
                        } else {
                            this.sendDataInfo.woApplyDetails = val.arrlistbychen;
                        }
                    } else {
                        if (
                            (key == "opmName" && val[key] == null) ||
                            (key == "depName" && val[key] == null) ||
                            (key == "depId" && val[key] == null) ||
                            (key == "opmId" && val[key] == null)
                        ) {
                            this.sendDataInfo[key] = this.sendDataInfo[key];
                        } else if (val[key] == null || val[key] === "") {
                        } else {
                            this.sendDataInfo[key] = val[key];
                        }
                        this.sendDataInfo.totalMoney = 0;
                        this.sendDataInfo.totalNumber = 0;
                        this.sendDataInfo.totalCount = 0;
                    }
                }
                if (!val.salesName || !val.salesId || !val.recName || !val.recId) {
                    this.$http.queryDefaultSales({
                        ids: [val.cmId]
                    }).then((res) => {
                        if (res && res.status == 200) {
                            for (const key in res.result) {
                                if (!this.sendDataInfo[key]) {
                                    this.sendDataInfo[key] = res.result[key];
                                }
                            }
                        }
                    })
                }
                this.sendDataInfo.woApplyDetails.forEach((item, index) => {
                    this.sendDataInfo.totalMoney += item.rrdPsmoney;
                    this.sendDataInfo.totalNumber += item.oldNum;
                    this.calculatePrice(false, index)
                });
                this.sendDataInfo.totalCount = this.sendDataInfo.woApplyDetails.length;
                this.DialogExtract = false;
                this.$nextTick(() => {
                    this.selectedDetailsIndex = 0;
                    let refsElTable = this.$refs.mxTableRef;
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                    );
                    this.nextFocus(0);
                });
            }
            this.parentSearchData.stId = this.sendDataInfo.stId;
            this.parentSearchData.cmId = this.sendDataInfo.cmId;
            this.parentSearchData.coId = this.sendDataInfo.coId;
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField, nosField, setField, flag) {
            console.log(sId, index, type, sField, fField, nosField, setField, flag, "测试");
            setTimeout(() => {
                this.showDialog = false;
            }, 16.7);
            if (type == "salesName" || type == "caiAddress" || type == "recName" || type == 'secondcmName') {
                if (this.sendDataInfo.cmId == "") {
                    return this.$message({
                        message: "请先选择销售单位",
                        type: "warning",
                    });
                }
            }
            if (type == 'sprmId') {
                if (this.sendDataInfo.cmId == "") {
                    return this.$message({
                        message: "请先选择销售单位",
                        type: "warning",
                    });
                }
                if (this.sendDataInfo.opmId == "") {
                    return this.$message({
                        message: "请先选择业务员",
                        type: "warning",
                    });
                }
                if (this.sendDataInfo.salesId == "") {
                    return this.$message({
                        message: "请先选择对方业务员",
                        type: "warning",
                    });
                }
                if (this.sendDataInfo.recId == "") {
                    return this.$message({
                        message: "请先选择收货员",
                        type: "warning",
                    });
                }
                
                if (this.sendDataInfo.coId == "") {
                    return this.$message({
                        message: "请先选择货主",
                        type: "warning",
                    });
                }
            }
            this.DialogVisible = true;
            removeEventListener("keyup", this.keyUp);
            this.seId = sId;
            this.seIndex = index;
            if (setField != undefined) {
                this.setField = setField;
            } else {
                this.setField = ""
            }
            this.oneFlag = false
            if (type == 'caiAddress') {
                this.oneFlag = true
            }
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            this.nosField = nosField;
            if (type == "bgmName") {
                console.log(flag);
                this.parentSearchData.surgeryType = this.sendDataInfo.surgeryType
                this.isRepetition = false
                if (flag) {
                    this.isRepetition = true
                    this.isRepetitionList = this.sendDataInfo.woApplyDetails
                }
                for (let key in this.sendDataInfo) {
                    this.parentSearchData[key] = this.sendDataInfo[key];
                }
                if (!this.nextSearch)
                    this.parentSearchData.bgmName =
                        this.sendDataInfo.woApplyDetails[this.seIndex].bgmName;
                if (this.parentSearchData.bgmName) {
                    let fh = 0;
                    if (this.parentSearchData.bgmName.indexOf(",") != -1) {
                        fh = ",";
                    } else if (this.parentSearchData.bgmName.indexOf("，") != -1) {
                        fh = "，";
                    }
                    if (fh !== 0) {
                        const str = this.parentSearchData.bgmName;
                        const list = str.split(fh);
                        this.parentSearchData.bgmName = list[0] || "";
                        this.parentSearchData.manufacturer = list[1] || "";
                    } else {
                        this.parentSearchData.manufacturer = "";
                    }
                } else {
                    this.parentSearchData.bgmName = "";
                    this.parentSearchData.manufacturer = "";
                }
                this.selectedDetailsIndex = this.seIndex;
                let refsElTable = this.$refs.mxTableRef;
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(
                    this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                );
                return;
            }
            for (const key in this.sendDataInfo) {
                if (this.sendDataInfo[key] != null && this.sendDataInfo[key] !== "") {
                    this.parentSearchData[key] = this.sendDataInfo[key];
                } else {
                    this.parentSearchData[key] = ""
                }
            }
            if (type == 'secondcmName') {
                delete this.parentSearchData.stId
            }


        },

        // 不可赋值字段
        noSetField(val) {
            let arr = this.nosField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },

        // 赋值字段
        paramValue(val) {
            console.log(this.sField, val);
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                if (
                    (item == "depName" && (val[item] == null || val[item] == "" || val[item] == 0)) ||
                    (item == "opmName" && (val[item] == null || val[item] == "" || val[item] == 0)) ||
                    (item == "depId" && (val[item] == null || val[item] == "" || val[item] == 0)) ||
                    (item == "opmId" && (val[item] == null || val[item] == "" || val[item] == 0))
                ) {
                    this.sendDataInfo[item] = this.sendDataInfo[item];
                } else if (this.seType == 'cmName' && this.actionData.formType == '合并') {
                    if (item == 'payMethod' || item == 'settleMethod' || item == 'dismode' || item == 'billType') {
                        if (val[item]) {
                            this.sendDataInfo[item] = val[item];
                        }
                    } else {
                        this.sendDataInfo[item] = val[item];
                    }
                } else {
                    this.sendDataInfo[item] = val[item];
                }
            });
            this.$nextTick(() => {
                this.nextFocus(this.seIndex, this.fField);
            });
        },

        // 清除赋值字段数据
        clearValue() {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },

        // 规则校验结果：有预警/拦截则弹窗，返回是否拦截(level==0)
        appendRuleResult(result) {
            if (!result || !result.length) return false;
            result.forEach((item) => this.dialogList.push(item));
            this.showDialog = true;
            return this.dialogList.some((item) => item.level == 0);
        },

        // 提示弹窗关闭：仅预警(showStatus == -1)时用户确认后继续提交
        showClose() {
            this.showDialog = false;
            if (this.showStatus == -1) {
                // 重置标记，避免影响其它复用该弹窗的规则校验
                this.showStatus = null;
                this.sub();
            }
        },

        hasSetField(...fields) {
            return fields.every((f) => this.sField.indexOf(f) != -1);
        },

        clearSalesFields(valObj) {
            if (valObj) {
                valObj.salesId = "";
                valObj.salesName = "";
            }
            this.sendDataInfo.salesId = "";
            this.sendDataInfo.salesName = "";
        },

        clearRecFields(valObj) {
            if (valObj) {
                valObj.recId = "";
                valObj.recName = "";
            }
            this.sendDataInfo.recId = "";
            this.sendDataInfo.recName = "";
        },

        // 选择销售单位：校验单位 → 查默认业务员 → 校验业务员/收货员 → 赋值
        async handleCmNameSelect(val) {
            this.showDialog = false;
            this.dialogList = [];
            this._cmSelectToken = (this._cmSelectToken || 0) + 1;
            const token = this._cmSelectToken;
            const formId = this.formDataList[0].jciId;
            const isStale = () => token !== this._cmSelectToken;

            try {
                const checkRes = await this.$http.checkCustomerSale({
                    formId,
                    unitId: val.cmId,
                });
                if (isStale()) return;
                if (!checkRes || checkRes.status != 200) {
                    this.lineMessageBox(checkRes);
                    this.parentSearchData.cmId = "";
                    this.clearValue();
                    return;
                }
                if (this.appendRuleResult(checkRes.result)) return;

                this.parentSearchData.cmId = val.cmId;
                this.sendDataInfo.cmId = val.cmId;
                this.sendDataInfo.cmName = val.cmName;
                if (val.creditperiod && val.creditperiod !== 0) {
                    this.sendDataInfo.creditperiod = val.creditperiod;
                    this.sendDataInfo.lastRecedate = this.queryDay(val.creditperiod);
                }
                this.clearSalesFields();
                this.clearRecFields();

                let valObj = { ...val };
                try {
                    const defaultRes = await this.$http.queryDefaultSales({ ids: [val.cmId] });
                    if (isStale()) return;
                    if (defaultRes && defaultRes.status == 200) {
                        valObj = { ...val, ...defaultRes.result };
                    } else {
                        this.paramValue(val);
                        return;
                    }
                } catch (rej) {
                    if (isStale()) return;
                    this.lineMessageBox(rej);
                    this.paramValue(val);
                    return;
                }

                const needSales =
                    valObj.salesName &&
                    valObj.salesId &&
                    this.hasSetField("salesName", "salesId");
                if (!needSales) {
                    this.paramValue(valObj);
                    return;
                }

                try {
                    const salesRes = await this.$http.checkSalesSale({
                        formId,
                        salesId: valObj.salesId,
                    });
                    if (isStale()) return;
                    if (!salesRes || salesRes.status != 200) {
                        this.clearSalesFields(valObj);
                        this.clearRecFields(valObj);
                        this.lineMessageBox(salesRes);
                        this.paramValue(valObj);
                        return;
                    }
                    if (this.appendRuleResult(salesRes.result)) {
                        this.clearSalesFields(valObj);
                        this.clearRecFields(valObj);
                        this.paramValue(valObj);
                        return;
                    }
                    this.sendDataInfo.salesName = valObj.salesName;
                    this.sendDataInfo.salesId = valObj.salesId;
                } catch (rej) {
                    if (isStale()) return;
                    this.clearSalesFields(valObj);
                    this.clearRecFields(valObj);
                    this.lineMessageBox(rej);
                    this.paramValue(valObj);
                    return;
                }

                const needRec =
                    valObj.recName &&
                    valObj.recId &&
                    this.hasSetField("recName", "recId");
                if (!needRec) {
                    this.paramValue(valObj);
                    return;
                }

                try {
                    const recRes = await this.$http.checkRecSalesSale({
                        formId,
                        salesId: valObj.recId,
                    });
                    if (isStale()) return;
                    if (!recRes || recRes.status != 200) {
                        this.clearRecFields(valObj);
                        this.lineMessageBox(recRes);
                        this.paramValue(valObj);
                        return;
                    }
                    if (this.appendRuleResult(recRes.result)) {
                        this.clearRecFields(valObj);
                    }
                    this.paramValue(valObj);
                } catch (rej) {
                    if (isStale()) return;
                    this.clearRecFields(valObj);
                    this.lineMessageBox(rej);
                    this.paramValue(valObj);
                }
            } catch (rej) {
                if (isStale()) return;
                this.lineMessageBox(rej);
                this.parentSearchData.cmId = "";
                this.clearValue();
            }
        },

        // 根据账期(day)与销售日期计算收款日期，返回时间戳
        // isCD=1 抽单：销售日期按「下月1号」计算；否则按实际销售日期
        // 月偏移：30→当月，60→下月，90→下下月；45→下月，75→下下月（floor((day-1)/30)）
        // 30/60/90：固定目标月30号收款（1-30号开单均同）
        // 45/75：1-15号开单→目标月15号；16-30号开单→目标月30号
        queryDay(day) {
            if (!this.sendDataInfo.woamSaledate || !day) {
                return null;
            }
            const creditDay = Number(day);
            // 抽单：以下月1号作为销售日期基准
            const saleDate = this.sendDataInfo.isPick == 1
                ? this.$moment(this.sendDataInfo.woamSaledate).add(1, "months").startOf("month")
                : this.$moment(this.sendDataInfo.woamSaledate);
            const saleDay = saleDate.date();
            const monthOffset = Math.floor((creditDay - 1) / 30);
            let payDay;
            if (creditDay % 30 === 0) {
                // 30、60、90：一律月末30号
                payDay = 30;
            } else {
                // 45、75：上半月15号，下半月30号
                payDay = saleDay <= 15 ? 15 : 30;
            }
            const targetDate = saleDate.clone().add(monthOffset, "months");
            payDay = Math.min(payDay, targetDate.daysInMonth());
            return targetDate.date(payDay).startOf("day").valueOf();
        },

        // 通用表单规则校验：通过返回 true；失败/拦截返回 false
        // 拦截时默认保留原值，避免把已选中的合法数据清掉
        async runRuleCheck(requestPromise, { clearOnFail = true, clearOnBlock = false } = {}) {
            this.showDialog = false;
            this.dialogList = [];
            try {
                const res = await requestPromise;
                if (!res || res.status != 200) {
                    this.lineMessageBox(res);
                    if (clearOnFail) this.clearValue();
                    return false;
                }
                if (this.appendRuleResult(res.result)) {
                    if (clearOnBlock) this.clearValue();
                    return false;
                }
                return true;
            } catch (rej) {
                this.lineMessageBox(rej);
                if (clearOnFail) this.clearValue();
                return false;
            }
        },

        isValidMeta(v) {
            return v != null && v !== "" && v !== "null";
        },

        // 对方业务员
        async handleSalesNameSelect(val) {
            const ok = await this.runRuleCheck(
                this.$http.checkSalesSale({
                    formId: this.formDataList[0].jciId,
                    salesId: val.salesId,
                })
            );
            if (ok) this.paramValue(val);
        },

        // 货主
        async handleCoNameSelect(val) {
            const ok = await this.runRuleCheck(
                this.$http.checkSuComey({
                    formId: this.formDataList[0].jciId,
                    coId: val.coId,
                })
            );
            if (!ok) return;
            this.coId = val.coId;
            this.sendDataInfo.ormId = this.ormId;
            this.paramValue(val);
        },

        // 自提人
        async handlePickupNameSelect(val) {
            const ok = await this.runRuleCheck(
                this.$http.fromruleCheckSuDismode({
                    formId: this.formDataList[0].jciId,
                    pickupId: val.pickupId,
                    dismode: this.sendDataInfo.dismode,
                })
            );
            if (ok) this.paramValue(val);
        },

        // 收货员（检索可能回 salesId 或 recId）
        async handleRecNameSelect(val) {
            const salesId = val.salesId || val.recId;
            if (!salesId) {
                this.clearValue();
                return;
            }
            const ok = await this.runRuleCheck(
                this.$http.checkRecSalesSale({
                    formId: this.formDataList[0].jciId,
                    salesId,
                })
            );
            if (ok) this.paramValue(val);
        },

        // 物流公司
        async handleCompanyNameSelect(val) {
            const ok = await this.runRuleCheck(
                this.$http.checkLogicvality({ ids: [val.loId] })
            );
            if (!ok) return;
            if (this.setField) {
                this.setField.split(",").forEach((field) => {
                    if (field) this.sendDataInfo[field] = val[field];
                });
            } else {
                this.sendDataInfo.companyName = val.companyName;
                this.sendDataInfo.loId = val.loId;
            }
        },

        // 提取销售合同
        handleHtSelect(val) {
            for (const key in val) {
                this.sendDataInfo[key] = val[key];
            }
            this.parentSearchData.cmId = val.cmId || "";
            this.sendDataInfo.woApplyDetails = [];
            // 合同未带业务员时，避免沿用上一客户的业务员
            if (!val.salesId || !val.salesName) {
                this.clearSalesFields();
            }
            if (!val.recId || !val.recName) {
                this.clearRecFields();
            }
        },

        collectDetailTypesAndRates(currentVal) {
            const bgiTypeArr = [];
            const bgiRateArr = [];
            const details = this.sendDataInfo.woApplyDetails || [];
            for (let i = 0; i < details.length; i++) {
                const v = details[i];
                if (this.isValidMeta(v.bgiType)) bgiTypeArr.push(v.bgiType);
                if (this.seIndex != i && this.isValidMeta(v.outRate)) {
                    bgiRateArr.push(v.outRate);
                }
            }
            if (currentVal) {
                if (this.isValidMeta(currentVal.outRate)) bgiRateArr.push(currentVal.outRate);
                if (this.isValidMeta(currentVal.bgiType)) bgiTypeArr.push(currentVal.bgiType);
            }
            return {
                bgiTypeArr: bgiTypeArr.filter((item) => this.isValidMeta(item)),
                bgiRateArr,
            };
        },

        resetBgmDetail() {
            this.$set(
                this.sendDataInfo.woApplyDetails,
                this.seIndex,
                JSON.parse(JSON.stringify(this.detaislDataInfo))
            );
        },

        // 选品后：数量/金额归零，保留并校正单价与含税价，避免「单价为0但金额不为0」
        normalizeSelectedBgmPrices(target, source) {
            target.woadPnumber = 0;
            target.tbNumber = 0;
            target.psmoney = 0;
            target.money = 0;
            target.rrPsmoney = 0;
            target.psprice = source.psprice || 0;
            target.price = source.price || 0;
            target.saleQuprice = source.saleQuprice || 0;
            target.saleQumoney = 0;
            target.newPsprice = source.psprice || 0;
        },

        applySetFieldToDetail(target, source) {
            if (!this.setField) return;
            this.setField.split(",").forEach((field) => {
                if (field && source[field] != null && source[field] !== "") {
                    target[field] = source[field];
                }
            });
        },

        buildBgmDetailItem(raw) {
            const item = { ...raw };
            const numberList = (this.mxForm.jurconfigform || [])
                .filter((f) => f.fieldType == "number")
                .map((f) => f.entityField);
            const newItem = { ...this.detaislDataInfo };

            for (const key in this.detaislDataInfo) {
                const srcVal = item[key];
                const isNumberField = numberList.includes(key);
                if (isNumberField && (srcVal === undefined || srcVal === null || srcVal === "" || srcVal === "null")) {
                    newItem[key] = 0;
                } else {
                    newItem[key] = srcVal != undefined && srcVal != null ? srcVal : "";
                }
            }

            newItem.isTicket = Number(this.ticket) || "";
            this.applySetFieldToDetail(newItem, item);
            // 金额归零与价格校正放在 setField 之后，防止带回脏金额
            this.normalizeSelectedBgmPrices(newItem, item);
            return newItem;
        },

        applyBgmDetail(val) {
            const targetItem = this.sendDataInfo.woApplyDetails[this.seIndex];
            if (!targetItem) return;
            Object.assign(targetItem, val);
            targetItem.isTicket = Number(this.ticket);
            this.$nextTick(() => {
                this.applySetFieldToDetail(targetItem, val);
                this.normalizeSelectedBgmPrices(targetItem, val);
                this.parentSearchData.bgmId = "";
                this.parentSearchData.bgmName = "";
                this.tableNextFocus(this.fField, this.seIndex);
                this.selectedDetailsIndex = this.seIndex;
                this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex] = targetItem;
                const refsElTable = this.$refs.mxTableRef;
                if (refsElTable) {
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                    );
                }
            });
        },

        // 商品明细
        async handleBgmNameSelect(val) {
            if (Array.isArray(val)) {
                if (val.length > 0) this.bgmSelect(val);
                return;
            }
            if (this.isValidMeta(val.expidate) && val.expidate < this.$common.getNewDayTime()) {
                this.tableNextFocus("bgmName", this.seIndex);
                this.$message({
                    message: "该品种已过期，不允许销售!",
                    type: "error",
                });
                return;
            }

            val.costAmount = 0;
            val.costMoney = 0;
            const { bgiTypeArr, bgiRateArr } = this.collectDetailTypesAndRates(val);

            this.showDialog = false;
            this.dialogList = [];
            try {
                const res = await this.$http.checkScopeSale({
                    formId: this.mxForm.jciId,
                    unitId: this.sendDataInfo.cmId,
                    bgmId: [val.bgmId],
                    bgsId: [val.bgsId],
                    ormId: this.ormId,
                    salesId: this.sendDataInfo.salesId,
                    bgiTypes: bgiTypeArr,
                    taxs: bgiRateArr,
                    recId: this.sendDataInfo.recId,
                    hospitalId: this.sendDataInfo.hospitalId || "",
                });
                if (!res || res.status != 200) {
                    this.lineMessageBox(res);
                    this.resetBgmDetail();
                    return;
                }
                if (this.appendRuleResult(res.result)) {
                    this.resetBgmDetail();
                    return;
                }
                this.applyBgmDetail(val);
            } catch (rej) {
                this.lineMessageBox(rej);
                this.resetBgmDetail();
            }
        },

        //检索带回数据
        changeInputModel(val) {
            // 原条件 val != "" || val != undefined 恒为 true
            if (val == null || val === "") return;
            this.DialogVisible = false;
            this.$nextTick(() => {
                addEventListener("keyup", this.keyUp);
                if (val.nextSearchId) {
                    this.nextSearch = true;
                    this.parentSearchData.bgmId = val.bgmId;
                    this.parentSearchData.bgmName = val.bgmName;
                    this.openSearch(
                        val.nextSearchId,
                        this.seIndex,
                        "bgmName",
                        "",
                        "woadPnumber",
                        this.nosField,
                        this.setField,
                        true
                    );
                    return;
                }
                this.nextSearch = false;
                const handlers = {
                    cmName: this.handleCmNameSelect,
                    salesName: this.handleSalesNameSelect,
                    coName: this.handleCoNameSelect,
                    pickupName: this.handlePickupNameSelect,
                    bgmName: this.handleBgmNameSelect,
                    recName: this.handleRecNameSelect,
                    ht: this.handleHtSelect,
                    companyName: this.handleCompanyNameSelect,
                };
                const handler = handlers[this.seType];
                if (handler) {
                    handler.call(this, val);
                } else {
                    this.paramValue(val);
                }
            });
        },
        //多选商品数据处理
        async bgmSelect(val) {
            if (!val || !val.length) return;

            const bgmIds = [];
            const bgsIds = [];
            let expired = false;

            for (let i = 0; i < val.length; i++) {
                const item = val[i];
                if (this.isValidMeta(item.expidate) && item.expidate < this.$common.getNewDayTime()) {
                    expired = true;
                }
                item.costAmount = item.costAmount || 0;
                item.costMoney = item.costMoney || 0;
                bgmIds.push(item.bgmId);
                bgsIds.push(item.bgsId);
            }

            if (expired) {
                return this.$message({
                    message: "该品种已过期，不允许销售!",
                    type: "error",
                });
            }

            const bgiTypeArr = [];
            const bgiRateArr = [];
            const details = this.sendDataInfo.woApplyDetails || [];
            for (let i = 0; i < details.length; i++) {
                const v = details[i];
                if (this.isValidMeta(v.bgiType) && v.bgmName != "") {
                    bgiTypeArr.push(v.bgiType);
                }
                if (this.seIndex != i && this.isValidMeta(v.outRate) && v.bgmName != "") {
                    bgiRateArr.push(v.outRate);
                }
            }
            for (let i = 0; i < val.length; i++) {
                const item = val[i];
                if (this.isValidMeta(item.outRate) && item.bgmName != "") {
                    bgiRateArr.push(item.outRate);
                }
                if (this.isValidMeta(item.bgiType)) {
                    bgiTypeArr.push(item.bgiType);
                }
            }

            this.dialogList = [];
            try {
                const res = await this.$http.checkScopeSale({
                    formId: this.mxForm.jciId,
                    unitId: this.sendDataInfo.cmId,
                    bgmId: bgmIds,
                    bgsId: bgsIds,
                    ormId: this.ormId,
                    salesId: this.sendDataInfo.salesId,
                    bgiTypes: bgiTypeArr.filter((item) => this.isValidMeta(item)),
                    taxs: bgiRateArr,
                    recId: this.sendDataInfo.recId,
                    hospitalId: this.sendDataInfo.hospitalId || "",
                });
                if (!res || res.status != 200) {
                    this.lineMessageBox(res);
                    this.resetBgmDetail();
                    return;
                }
                if (this.appendRuleResult(res.result)) {
                    this.resetBgmDetail();
                    return;
                }

                this.sendDataInfo.woApplyDetails = (this.sendDataInfo.woApplyDetails || []).filter(
                    (item) => item.bgmId !== "" && item.bgmName !== ""
                );
                for (let i = 0; i < val.length; i++) {
                    this.sendDataInfo.woApplyDetails.push(this.buildBgmDetailItem(val[i]));
                }
            } catch (rej) {
                this.lineMessageBox(rej);
                this.resetBgmDetail();
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 打印方法
        showPrintPlan() {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        //确认新增
        sendDataAction(formName1) {
            this.$refs[formName1].validate(async (valid) => {
                if (valid) {
                    if (this.sendDataInfo.woApplyDetails.length < 1) {
                        this.$message({
                            message: "请添加明细",
                            type: "error",
                        });
                        return false;
                    } else {
                        this.sendDataInfo.woApplyDetails.forEach((item, index) => {
                            if (item.bgmId == "") {
                                this.sendDataInfo.woApplyDetails.splice(index, 1);
                            }
                        });
                    }
                    if (this.sendDataInfo.orderId == "") {
                        for (let j = 0; j < this.sendDataInfo.woApplyDetails.length; j++) {
                            const itemvs = this.sendDataInfo.woApplyDetails[j];
                            if (
                                itemvs.woadPnumber <= 0 ||
                                itemvs.woadPnumber > itemvs.saleableNum
                            ) {
                                this.$message({
                                    message: "请填写商品、合理的销售数量",
                                    type: "error",
                                });
                                this.$set(itemvs, "woadPnumber", 0);
                                this.$set(itemvs, "tbNumber", 0);
                                return false;
                            }
                        }
                    }
                    // 保存调用接口前，按金额重新计算单价/含税价等
                    this.sendDataInfo.woApplyDetails.forEach((item, index) => {
                        if (item.bgmId) {
                            this.calculatePrice(5, index);
                        }
                    });
                    for (let key in this.sendDataInfo) {
                        if (key == "") delete this.sendDataInfo[key];
                    }
                    this.sendDataInfo.totalCount = this.sendDataInfo.woApplyDetails.length
                    // 销售订单合同到期校验
                    let interceptData = {
                        unitId: this.sendDataInfo.cmId,
                        formId: this.formDataList[0].jciId,
                        conmId: this.sendDataInfo.conmId || "",
                    };
                    let addIntercept = await this.$http.checkSuContract(interceptData);
                    if (addIntercept.status == 200) {
                        if (addIntercept.result.length > 0) {
                            this.dialogList = addIntercept.result;
                            this.showStatus = this.dialogList.findIndex(
                                (item) => item.level == 0
                            );
                            this.showDialog = true;
                        } else {
                            this.sub();
                        }
                    } else {
                        this.$message.error(addIntercept.message);
                    }
                } else {
                    this.$message({
                        message: "请完善主表单必填信息",
                        type: "error",
                    });
                    return false;
                }
            });
        },
        async sub() {
            this.sendDataInfo.desuUdisuouts = []
            if (this.dataActionBox.actionType == 0) {
                if (this.pageType == "one") {
                    if (this.$route.name == 'storeDeliveryList') {//路由storeDeliveryList 是否是门店配送单页面
                        this.sendDataInfo.storeType = 1
                    }
                    var responseData = await this.$http[this.actionData.formType == '合并' ? 'woApplyaddByCoMerge' : 'addSalesOrder'](
                        this.sendDataInfo
                    );
                } else {
                    var responseData = await this.$http.addSalesOrderMerge(
                        this.sendDataInfo
                    );
                }
            } else {
                if (this.pageType == "one") {
                    var responseData = await this.$http.setSalesOrder(
                        this.sendDataInfo
                    );
                } else {
                    var responseData = await this.$http.setSalesOrderMerge(
                        this.sendDataInfo
                    );
                }
            }

            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$refs.operSelect.openBox(responseData.result);
                // this.$emit("drawerCancel");
                // this.init();
            } else {
                this.$message.error(responseData.message);
            }
        },
        drawerCancel() {
            this.$emit("drawerCancel", true);
        },
        conAdd() {
            this.init();
            this.dataActionBox.actionType = 0;
            this.initDefaultValue();
            this.checkIsBuyer();
        },
        //新增明细
        addDetail(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    var flag = false;
                    if (this.sendDataInfo.woApplyDetails.length > 0) {
                        const hasEmptyBgmId = this.sendDataInfo.woApplyDetails.some(item => item.bgmId === "");
                        if (hasEmptyBgmId) {
                            flag = true;
                            return this.$message({
                                message: "请不要重复新增空白行",
                                type: "warning",
                            });
                        }
                    }
                    if (flag) {
                        return;
                    }
                    if (this.sendDataInfo.woApplyDetails.length > 0) {
                        this.doCheckPrice(5, this.sendDataInfo.woApplyDetails.length - 1).then(res => {
                            if (!res) {
                                // 直接创建包含默认值的对象，避免使用$set逐个设置
                                const newDetailItem = { ...this.detaislDataInfo };
                                // 如果有字段值为null或undefined，将其转换为空字符串
                                for (const key in newDetailItem) {
                                    if (newDetailItem[key] == null) {
                                        newDetailItem[key] = "";
                                    }
                                }
                                this.sendDataInfo.woApplyDetails.push(newDetailItem);
                                // 使用变量缓存索引，避免重复计算
                                const newIndex = this.sendDataInfo.woApplyDetails.length - 1;
                                // 使用nextTick延迟DOM操作
                                this.$nextTick(() => {
                                    this.selectedDetailsIndex = newIndex;
                                    this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                                    const refsElTable = this.$refs.mxTableRef;
                                    if (refsElTable) {
                                        refsElTable.clearSelection();
                                        refsElTable.toggleRowSelection(
                                            this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                                        );
                                    }
                                });
                            }
                        });
                    } else {
                        // 直接创建包含默认值的对象，避免使用$set逐个设置
                        const newDetailItem = { ...this.detaislDataInfo };
                        // 如果有字段值为null或undefined，将其转换为空字符串
                        for (const key in newDetailItem) {
                            if (newDetailItem[key] == null) {
                                newDetailItem[key] = "";
                            }
                        }
                        this.sendDataInfo.woApplyDetails.push(newDetailItem);
                        // 使用变量缓存索引，避免重复计算
                        const newIndex = this.sendDataInfo.woApplyDetails.length - 1;
                        // 使用nextTick延迟DOM操作
                        this.$nextTick(() => {
                            this.selectedDetailsIndex = newIndex;
                            this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                            const refsElTable = this.$refs.mxTableRef;
                            if (refsElTable) {
                                refsElTable.clearSelection();
                                refsElTable.toggleRowSelection(
                                    this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                                );
                            }
                        });
                    }

                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        // 打开特价申请
        openPriceApplicationBox(goodsIndex = "") {
            if (this.sendDataInfo.woApplyDetails.length >= 1) {
                if (goodsIndex == "") {
                    var dataInfo =
                        this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex];
                } else {
                    var dataInfo = this.sendDataInfo.woApplyDetails[goodsIndex];
                }
                this.priceApplicationData.bgmId = dataInfo.bgmId;
                this.priceApplicationData.bgmName = dataInfo.bgmName;
                this.priceApplicationData.coId = this.sendDataInfo.coId;
                this.priceApplicationData.coName = this.sendDataInfo.coName;
                this.priceApplicationData.wosaSalecus =
                    this.sendDataInfo.woamSalecus;
                this.priceApplicationData.cmId = this.sendDataInfo.cmId;
                this.priceApplicationData.cmName = this.sendDataInfo.cmName;
                this.priceApplicationData.wosaAppprice = "";
                this.priceApplicationData.wosaAppreason = "";
                this.priceApplicationData.batchno = dataInfo.batchno;
                this.priceApplicationData.expidate = dataInfo.expidate;
                this.priceApplicationData.wosaEnddate = "";
                this.priceApplicationData.wosaMinprice = "";
                this.priceApplicationData.prodate = dataInfo.prodate;

                this.priceApplicationBox = true;
            } else {
                this.$message({
                    message: "请先添加明细数据",
                    type: "error",
                });
            }
        },

        // 新增特价申请
        async addSpecialPriceApply() {
            // this.initTime();
            if (this.priceApplicationData.wosaAppprice == "") {
                this.$message({
                    message: "请填写申请售价",
                    type: "error",
                });
                return false;
            }

            if (this.priceApplicationData.wosaEnddate == "") {
                this.$message({
                    message: "请选择截止日期",
                    type: "error",
                });
                return false;
            }

            let responseData = await this.$http.addSpecialPriceApply(
                this.priceApplicationData
            );
            if (responseData.status == 200) {
                this.priceApplicationBox = false;
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 打开缺货登记
        openStockRegisterBox() {
            if (this.sendDataInfo.woApplyDetails.length >= 1) {
                var dataInfo =
                    this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex];
                console.log("缺货登记", dataInfo);
                this.stockRegisterData.bgmId = dataInfo.bgmId;
                this.stockRegisterData.bgmName = dataInfo.bgmName;
                this.stockRegisterData.cmId = this.sendDataInfo.cmId;
                this.stockRegisterData.cmName = this.sendDataInfo.cmName;
                this.stockRegisterData.coId = this.sendDataInfo.coId;
                this.stockRegisterData.coName = this.sendDataInfo.coName;
                this.stockRegisterData.spec = dataInfo.spec;
                this.stockRegisterData.placeorigin = dataInfo.placeorigin;
                this.stockRegisterData.bgpUnitmeasurement = dataInfo.bgpUnitmeasurement;
                this.stockRegisterBox = true;
            } else {
                this.$message({
                    message: "请先添加明细数据",
                    type: "error",
                });
            }
        },

        // 新增缺货登记
        async addShortageRegistration() {
            if (this.stockRegisterData.wolrRegnumber == "") {
                this.$message({
                    message: "请先填写登记数量",
                    type: "error",
                });
                return false;
            }

            let responseData = await this.$http.addShortageRegistration(
                this.stockRegisterData
            );
            if (responseData.status == 200) {
                this.stockRegisterBox = false;
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 检测最低价
        async getGoodsSockPrice(goodsIndex) {
            var dataInfo = this.sendDataInfo.woApplyDetails[goodsIndex];
            if (!dataInfo.psprice) {
                return false;
            }

            var sendData = {
                bgmId: dataInfo.bgmId,
                batchno: dataInfo.batchno,
                wosaAppprice: dataInfo.psprice,
                expidate: dataInfo.expidate,
                prodate: dataInfo.prodate,
                wosaSalecus: this.sendDataInfo.woamSalecus,
            };

            let responseData = await this.$http.getGoodsSockPrice(sendData);
            if (responseData.status == 200) {
                // this.stockRegisterBox = false
                // this.$message({
                // 	message: '操作成功',
                // 	type: 'success'
                // });
            } else {
                this.openPriceApplicationBox(goodsIndex);
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        //含税价拦截
        async doCheckPrice(cate, index, field = "psprice") {
            const detail = this.sendDataInfo.woApplyDetails[index];
            if (!detail) return false;
            let pspriceObj = {
                coId: this.sendDataInfo.coId, //货主ID
                bgmId: detail.bgmId, //商品ID
                psprice: detail.psprice, //商品价格
                costPrice: detail.woadWcost, //成本价
                cmId: this.sendDataInfo.cmId, //客户ID
                bgsId: detail.bgsId, //库存ID
                lowestPrice: detail.lowestPrice, //最低售价
                newPsprice: detail.newPsprice,
                priceListId: detail.priceListId, //销售价目表（安图使用）
            };
            // 校验后重算需与输入框 @input 保持同一口径：newPsprice 用 9，其余沿用传入 cate
            const calcCate = field === "newPsprice" ? 9 : cate;
            // 聚焦当前编辑字段的输入框，并防止该列未渲染导致报错
            const inputRef = this.$refs[field] && this.$refs[field][index];
            const res = await this.$http.checkPrice(pspriceObj)
            if (res.status == 200) {
                this.calculatePrice(calcCate, index);
                return false;
            } else if (res.status == 300) {
                this.$message({
                    message: res.message,
                    type: "warning",
                });
                this.calculatePrice(calcCate, index);
                return false;
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                });
                // 校验不通过：清空当前编辑字段并重新聚焦
                this.sendDataInfo.woApplyDetails[index][field] = 0;
                this.calculatePrice(calcCate, index);
                if (inputRef) inputRef.focus();
                if (this.sendDataInfo.woApplyDetails.some(item => item.bgmId == "" || item.bgmName == "")) {
                    this.sendDataInfo.woApplyDetails.splice(this.sendDataInfo.woApplyDetails.length - 1, 1)
                }
                return true;
            }
        },
        // 计算价格
        calculatePrice(cate = 1, index, flag, field) {
            const info = this.sendDataInfo.woApplyDetails[index];
            if (field == 'tbNumber') {
                info.tbNumber = info.woadPnumber;
            }
            // 安全检查，确保数据有效性
            if (this.sendDataInfo.orderId == "") {
                if (info.woadPnumber < 0 || isNaN(info.woadPnumber)) {
                    if (!flag) {
                        this.$message({
                            message: "请先填写合理的销售数量",
                            type: "error",
                        });
                    }
                    // 直接赋值，避免使用$set
                    info.woadPnumber = 0;
                    info.money = 0;
                    info.psmoney = 0;
                    info.gross = 0; //毛利
                    info.costMoney = 0; //含税成本金额
                    info.costAmount = 0; //成本金额
                    if (!flag) {
                        this.calculatePrice(cate, index, true, field)
                    }
                    return false;
                } else if (info.woadPnumber > info.saleableNum) {
                    this.sendDataInfo.woApplyDetails[index].woadPnumber = info.saleableNum;
                    if (!flag) {
                        this.calculatePrice(cate, index, true, field)
                    }
                    this.$message({
                        message: "销售数量不能大于可销数量",
                        type: "error",
                    });
                    return
                }
            }

            // 缓存常用变量，避免重复访问
            const details = this.sendDataInfo.woApplyDetails[index];
            const quantity = parseFloat(info.woadPnumber) || 0;
            const taxRate = parseFloat(info.outRate) || 0;
            const price = parseFloat(info.price) || 0;
            const psprice = parseFloat(info.psprice) || 0;
            const psmoney = parseFloat(info.psmoney) || 0;
            const costMoney = parseFloat(info.woadWcost) || 0;
            const costAmount = parseFloat(info.costPrice) || 0;

            // 创建税率计算辅助函数
            const calculateTaxFactor = () => NP.plus(1, NP.divide(taxRate, 100));
            const calculateTaxAdjustedPrice = (basePrice) => this.$common.getDecimalInfo(2, NP.times(basePrice, calculateTaxFactor()));
            const calculateBaseFromTaxed = (taxedValue) => this.$common.getDecimalInfo(3, NP.divide(taxedValue, calculateTaxFactor()));

            switch (cate) {
                case 1: // 通过单价计算全部
                    // 计算含税价格 单价+单价*税率/100
                    details.psprice = calculateTaxAdjustedPrice(price);
                    details.psmoney = this.$common.getDecimalInfo(3, NP.times(details.psprice, quantity)); // 计算含税金额 含税价格*数量
                    details.money = calculateBaseFromTaxed(details.psmoney);
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, details.money)); // 计算税额
                    details.taxAmount = details.taxAmount == 0 ? 0 : details.taxAmount;
                    // 含税价变化，新含税价同步
                    this.$set(details, "newPsprice", details.psprice);
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((details.psprice || 0), (info.orPsprice || 0)), 100));
                    }
                    break;
                case 2: // 通过含税价格计算全部
                    // 计算含税金额 含税价格*数量
                    details.psmoney = quantity === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(psprice, quantity));
                    // 计算金额 含税金额/(税率/100+1)
                    const midmoney = calculateBaseFromTaxed(details.psmoney);
                    details.money = this.$common.getDecimalInfo(3, midmoney);
                    // 计算单价 金额/数量
                    details.price = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, quantity));
                    // 含税价变化，新含税价同步（$set 保证列表刷新）
                    this.$set(details, "newPsprice", psprice);
                    //计算税额
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, details.money));
                    details.taxAmount = details.taxAmount == 0 ? 0 : details.taxAmount;
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((psprice || 0), (info.orPsprice || 0)), 100));
                    }
                    break;
                case 3: // 通过金额计算全部
                    // 计算单价  金额 / 数量
                    const calculatedPrice = quantity ? this.$common.getDecimalInfo(2, NP.divide(info.money, quantity)) : 0;
                    details.price = calculatedPrice;

                    // 计算含税价格 单价+单价*税率/100
                    const taxAdjustedPrice = calculateTaxAdjustedPrice(calculatedPrice);
                    details.psprice = taxAdjustedPrice
                    // 计算含税金额 含税价格*数量
                    details.psmoney = this.$common.getDecimalInfo(3, NP.times(taxAdjustedPrice, quantity));
                    // 含税价变化，新含税价同步
                    this.$set(details, "newPsprice", details.psprice);
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((details.psprice || 0), (info.orPsprice || 0)), 100));
                    }
                    //计算税额
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, info.money));
                    details.taxAmount = details.taxAmount == 0 ? 0 : details.taxAmount;
                    break;
                case 4: // 通过含税金额计算全部
                    // 计算总金额 含税金额/(税率/100+1)
                    const midmoney2 = calculateBaseFromTaxed(psmoney);
                    details.money = this.$common.getDecimalInfo(3, midmoney2);
                    details.psprice = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(psmoney, quantity)); // 计算含税价格  含税金额 / 数量
                    // 计算单价 金额/数量
                    details.price = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney2, quantity));
                    // 含税价变化，新含税价同步（$set 保证列表刷新）
                    this.$set(details, "newPsprice", details.psprice);
                    //计算税额
                    details.taxAmount = quantity === 0 ? 0 : this.$common.getDecimalInfo(3, NP.minus(psmoney, details.money));
                    details.taxAmount = details.taxAmount == 0 ? 0 : details.taxAmount;
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((details.psprice || 0), (info.orPsprice || 0)), 100));
                    }
                    break;
                case 6://销售报价
                    details.saleQumoney = this.$common.getDecimalInfo(3, NP.times(info.saleQuprice || 0, quantity));
                    break;
                case 7://报价金额
                    details.saleQuprice = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(info.saleQumoney, quantity));
                    break;
                case 8://通过含税原价
                    details.orPsmoney = this.$common.getDecimalInfo(3, NP.times((info.orPsprice || 0), quantity));
                    details.orMoney = calculateBaseFromTaxed(details.orPsmoney);
                    details.orPrice = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(details.orMoney, quantity));
                    details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((psprice || 0), (info.orPsprice || 0)), 100));
                    break;
                case 9://通过不含税原价
                    // 计算含税原价格 不含税原价+不含税原价*税率/100
                    details.orPsprice = calculateTaxAdjustedPrice(info.orPrice);
                    details.orPsmoney = this.$common.getDecimalInfo(3, NP.times((details.orPsprice || 0), quantity));
                    details.orMoney = this.$common.getDecimalInfo(3, NP.times((info.orPrice || 0), quantity));
                    details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((psprice || 0), (details.orPsprice || 0)), 100));
                    break;
                default:
                    details.saleQumoney = this.$common.getDecimalInfo(3, NP.times(info.saleQuprice || 0, quantity));
                    //通过数量计算
                    // 计算含税金额 含税价格*数量
                    const midmoney3 = quantity === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, quantity));
                    details.psmoney = this.$common.getDecimalInfo(3, midmoney3);
                    // 计算总金额 含税金额/(税率/100+1)
                    details.money = calculateBaseFromTaxed(details.psmoney);
                    // 计算单价 金额/数量
                    details.price = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(details.money, quantity));
                    // 计算 wholeNum整件数量  woadPnumber 销售数量    整件数量= 销售数量/装箱规格
                    const wholeNum = parseFloat(info.packingSpec) > 0 && quantity > 0 ? Math.floor(NP.divide(quantity, Number(info.packingSpec))) : 0;
                    details.wholeNum = wholeNum;
                    //计算 scatNum 零散数量   wholeNum 整件数量   packingSpec 装箱规格    零散数量=销售数量-(整件数量*装箱规格)
                    const scatNum = NP.minus(this.$common.getDecimalInfo(1, quantity), NP.times(wholeNum, Number(info.packingSpec)));
                    details.scatNum = isNaN(scatNum) || String(scatNum) == 'NaN' ? 0 : scatNum;
                    //计算税额
                    details.taxAmount = quantity === 0 ? 0 : this.$common.getDecimalInfo(3, NP.minus(details.psmoney, details.money));
                    details.taxAmount = details.taxAmount == 0 ? 0 : details.taxAmount;
                    // 含税成本金额 = 含税成本 * 数量
                    details.costMoney = this.$common.getDecimalInfo(3, NP.times(costMoney, quantity));
                    // 成本金额 = 库存成本 * 数量
                    details.costAmount = this.$common.getDecimalInfo(3, NP.times(costAmount, quantity));
                    //通过含税原价计算
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.orPsmoney = this.$common.getDecimalInfo(3, NP.times((info.orPsprice || 0), quantity));
                        details.orMoney = calculateBaseFromTaxed(details.orPsmoney);
                        details.orPrice = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(details.orMoney, quantity));
                        details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((psprice || 0), (info.orPsprice || 0)), 100));
                    }
                    // 计算件数 采数/包装单位  件数=销售数量/装箱规格
                    if (
                        parseFloat(info.packingSpec) <= 0 ||
                        info.packingSpec == ""
                    ) {
                        details.pieceNum = 0;
                    } else {
                        details.pieceNum = this.$common.getDecimalInfo(1, NP.divide(quantity, info.packingSpec));
                    }
                    break;
            }

            // 计算折扣价格
            details.disPrice = this.$common.getDecimalInfo(2, NP.minus(info.disPreprice || 0, info.psprice || 0));

            // 退补金额 = (新含税价 - 含税价) * 退补数量（用计算后的最新值）
            const currNewPsprice = parseFloat(details.newPsprice) || 0;
            const currPsprice = parseFloat(details.psprice) || 0;
            const tbNumber = parseFloat(details.tbNumber) || 0;
            this.$set(
                details,
                "rrPsmoney",
                this.$common.getDecimalInfo(3, NP.times(NP.minus(currNewPsprice, currPsprice), tbNumber))
            );
            //均价=（含税金额psmoney-退补金额rrPsmoney）/数量woadPnumber
            details.avePrice = this.$common.getDecimalInfo(2, NP.divide(NP.minus(details.psmoney, details.rrPsmoney), details.woadPnumber));

            // 获取计算后的金额，确保是数字类型
            const moneyAfterTax = parseFloat(details.psmoney) || 0;
            const costMoneyAfterTax = parseFloat(details.costMoney) || 0;

            // 毛利 = 含税金额 - 成本含税金额
            details.gross = this.$common.getDecimalInfo(3, NP.minus(moneyAfterTax, costMoneyAfterTax));

            // 不含税毛利 = 金额 - 成本金额
            details.taxgross = this.$common.getDecimalInfo(3, NP.minus(parseFloat(details.money) || 0, parseFloat(details.costAmount) || 0));

            //毛利率
            details.grossProfit = moneyAfterTax != 0 ? this.$common.toFixed2(NP.divide(details.gross, moneyAfterTax), 2) : 0;

            // 更新所有总计数据
            this.updateTotalStats();
        },

        // 新增一个方法来计算总的统计数据
        updateTotalStats() {
            let totalMoney = 0;
            let totalGross = 0;
            let totalNumber = 0;
            let totalCostMoney = 0;
            let totalRrmoney = 0;

            // 单次遍历计算所有总计值，符合批量数据处理优化规范
            for (let i = 0; i < this.sendDataInfo.woApplyDetails.length; i++) {
                const detail = this.sendDataInfo.woApplyDetails[i];
                totalMoney += parseFloat(detail.psmoney) || 0;
                totalGross += parseFloat(detail.gross) || 0;
                totalNumber += parseFloat(detail.woadPnumber) || 0;
                totalCostMoney += parseFloat(detail.costMoney) || 0;
                totalRrmoney += parseFloat(detail.rrPsmoney) || 0;
            }

            this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, totalMoney);
            this.sendDataInfo.totalGprofit = this.$common.getDecimalInfo(3, totalGross);
            this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(1, totalNumber);
            this.sendDataInfo.totalCostMoney = this.$common.getDecimalInfo(3, totalCostMoney);
            this.sendDataInfo.totalRrmoney = this.$common.getDecimalInfo(3, totalRrmoney);
            this.sendDataInfo.totalCount = this.sendDataInfo.woApplyDetails.length;
        },

        //取消
        initActionBox(formName1, formName2) {
            this.$confirm(
                "确定取消" + this.dataActionBox.boxTitle + "吗?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    this.$emit("drawerCancel");
                    this.init();
                    this.$refs[formName1].resetFields();
                    this.$refs[formName2].resetFields();
                })
                .catch(() => { });
        },

        //初始化
        init() {
            for (let key in this.sendDataInfo) {
                if (key == "woApplyDetails") {
                    this.sendDataInfo[key] = [];
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            this.sendDataInfo.woamSaledate = this.$moment().valueOf();

            this.sendDataInfo.woApplyDetails = [];
            this.sendDataInfo.totalCount = 0;
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.orderType = 0; //orderType	订单类型0.药品订单1.器械订单
            this.checkIsBuyer();
        },

        // 选择业务员
        selectUserOne(data) {
            data.forEach((item) => {
                if (item.opmId == this.sendDataInfo.woamSalesman) {
                    this.sendDataInfo.depId = item.depId; //   业务部门
                    this.sendDataInfo.depName = item.depName; //   业务部门
                }
            });
        },
        initTime() {
            // this.getRequestData.start = this.$common.getStartTime()
            this.priceApplicationData.wosaEnddate = this.$common.getEndTime();
        },
        //上级流入
        openBox() {
            this.initTime();
            this.pageType = this.actionData.type;
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            this.showTabs = this.actionData.formData[0].jciName;
            var oldData = this.actionData.oldData;
            this.filterMainField();
            this.init();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.initDefaultValue();
                this.checkIsBuyer();
            } else if (this.dataActionBox.actionType == 1) {
                this.cmId = oldData.cmId;
                this.ormId = oldData.ormId
                    ? oldData.ormId
                    : JSON.parse(sessionStorage.getItem("loginInfo")).ormId;
                this.coId = oldData.coId;
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                for (const key in oldData) {
                    this.$set(this.sendDataInfo, key, oldData[key]);
                }
                this.parentSearchData.cmId = oldData.cmId;
                for (let key in this.sendDataInfo) {
                    if (this.sendDataInfo[key] == null) this.sendDataInfo[key] = "";
                }
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.$refs["tree"].init(this.sendDataInfo.woamId);
                        this.mxHeight = this.$common.getHeight();
                    }
                    this.initFocus();
                }, 16.7);
            });
        },
        // 默认值
        initDefaultValue() {
            let arr = this.formDataList[0].jurconfigform;
            arr.forEach((item) => {
                if (
                    item.defaultValue != "null" &&
                    item.defaultValue != null &&
                    item.defaultValue != ""
                ) {
                    this.sendDataInfo[item.entityField] = item.defaultValue;
                }
            });
            this.sendDataInfo.isWms = Number(this.sendDataInfo.isWms);
            this.sendDataInfo.woamSaledate = this.$moment().valueOf();
        },

        //删除明细
        deleteDetails() {
            this.sendDataInfo.woApplyDetails.splice(this.selectedDetailsIndex, 1);
            this.$nextTick(() => {
                if (this.sendDataInfo.woApplyDetails.length > 1) {
                    this.selectedDetailsIndex = Number(
                        this.selectedDetailsIndex - 1
                    );
                    this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                    let refsElTable = this.$refs.mxTableRef;
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                    );
                } else {
                    this.selectedDetailsIndex = 0;
                }
            });
        },

        // 判断是不是采购员
        checkIsBuyer() {
            if (this.dataActionBox.actionType != 0) return;
            let info = JSON.parse(sessionStorage.getItem("userInfo"));
            let ormInfo = JSON.parse(sessionStorage.getItem("ormInfo"));
            if (ormInfo.isDefaultopm == 1) {
                if (info.opmSalesperson == 1) {
                    this.sendDataInfo.depName = info.depName;
                    this.sendDataInfo.depId = info.depId;
                    this.sendDataInfo.opmName = info.opmName;
                    this.sendDataInfo.opmId = info.opmId;
                    this.tabForm[0].jurconfigform.forEach((item) => {
                        if (
                            item.entityField == "opmName" ||
                            item.entityField == "depName"
                        )
                            item.isChange = 0;
                    });
                }
            }
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item));
                    this.mxForm.jurconfigform.forEach((item1) => {
                        if (item1.fieldType == "number") {
                            this.$set(this.detaislDataInfo, item1.entityField, 0);
                        } else if (item1.fieldType == "search" && item1.setField) {
                            var arr = item1.setField.split(",");
                            arr.forEach((item2) => {
                                this.$set(this.detaislDataInfo, item2, "");
                            });
                        } else {
                            this.$set(this.detaislDataInfo, item1.entityField, "");
                        }
                    });
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                var index1 = 0
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    // if (key.jurconfigform[index].isShow == 1)
                    if (key.jurconfigform[index].isShow == 1) {
                        key.jurconfigform[index].isIndex = index1
                        index1++
                    }
                    this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);

                }
            });
            var arr = [{ entityField: "woApplyDetails" }];
            var obj = this.$common.filterMainFields(
                this.formDataList,
                arr,
                mainFormList[0]
            );
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key]);
            }
            this.$set(this.sendDataInfo, "woamSaledate", this.$moment().valueOf());
            this.$set(this.sendDataInfo, "orderType", 0);
            this.mxForm.jurconfigform.forEach((item) => {
                if (item.entityField == "isTicket") {
                    this.ticket = item.defaultValue;
                }
            });
        },
        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [63],
            });
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取字典数据
        async dictSurgeryqueryList() {
            let responseData = await this.$http.dictSurgeryqueryList({ surgeryName: "" });
            if (responseData.status == 200) {
                this.surgeryTypeList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        console.log(this.$route)
        this.$dbCache.Record_Get(4).then((res) => {//选择明细后不允许更换单位
            //明细拦截
            let obj = res
            if (obj.isEnable == 1) this.detailRules = true;
        });
        this.getPartDictionariesData()
        this.dictSurgeryqueryList()
        this.$nextTick(() => {
            this.openBox();

            this.isLoaded = true;
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        document.onkeydown = function () {
            if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                window.event.returnValue = false;
            }
        };
        // addEventListener('keydown', this.keyDown)
        addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener("keyup", this.keyUp);
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}

/* 上传图片 */
.upload {
    width: 200px;
    list-style: none;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.upload li {
    position: relative;
    width: 42px;
    height: 42px;
    margin-right: 5px;
    margin-bottom: 5px;
    border: 1px solid #dedede;
}

.upload .active_li {
    border: none;
}

.image_label {
    display: block;
    width: 42px;
    height: 42px;
}

.upload li:last-child {
    border: none;
}

.upload li:last-child .image_label {
    border: 1px dashed #838383;
}

.upload li:last-child .image_label:hover {
    border: 1px dashed #409eff;
    cursor: pointer;
}

.upload li:last-child:hover .icon {
    color: #409eff;
}

.upload li .icon {
    color: #838383;
    font-size: 20px;
    margin: 10px 0 0 10px;
}

.del {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 14px;
    z-index: 99;
    cursor: pointer;
}

.del:hover {
    color: #409eff;
}

.upload li:hover .del {
    display: inline-block;
}

::v-deep .el-image__error {
    font-size: 7px;
}

::v-deep .cus-image {
    width: 40px !important;
    height: 40px !important;
}

::v-deep .cus-image img {
    width: 40px !important;
    height: 40px !important;
}
</style>
<style>
.el-table .rowStyle {
    background: #fff7ca !important;
}
</style>